module.exports = __webpack_public_path__ + "static/media/ic_selected.8095a92c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_selected.svg
// module id = 289
// module chunks = 0